import * as React from 'react'
import { t } from 'ttag'
import YumButton from '../YumButton/YumButton'

export interface IStateProps {
  buttonText?: string
}

export interface IDispatchProps {
  setOnboardingStatusToIntegration(): void
}

type IProps = IStateProps & IDispatchProps

export default function YumChooseIntegrationBtn(props: IProps) {
  return (
    <YumButton size="small" onClick={props.setOnboardingStatusToIntegration}>
      {props.buttonText || t`Choose integration`}
    </YumButton>
  )
}
